<template>
<Nav />
<Content>
  <h3 class="has-text-danger">Dashboard Unauthorized!</h3>
</Content>
<Footer />
</template>

<script>
import Nav from '@/components/Nav.vue'
import Content from '@/components/Content.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'DashboardView',
    components: {Nav, Footer, Content, },
}
</script>
